// extracted by mini-css-extract-plugin
export var image = "MapBanner-module--image--675c7";